module.exports = __webpack_public_path__ + "static/media/opportunity.d33d0efc.jpg";